// extracted by mini-css-extract-plugin
export default {"input":"Auth_input__N0oVY"};